import React from 'react';
export function HotelPartnershipsSlide() {
  const hotels = [{
    name: 'Radisson Blu',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2poSXiMrLnpCYtYNHMxiJN/unnamed_%281%29.png',
    description: 'Colaboración para contenido de redes sociales'
  }, {
    name: 'Courtyard By Marriott',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5tLKfEpMZA6HNYkXwFXsV2/unnamed.png',
    description: 'Campaña de marketing digital'
  }, {
    name: 'Embassy Suites',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pBXSW7voUwq4e5dw9xqZxf/unnamed_%282%29.png',
    description: 'Contenido para redes sociales'
  }, {
    name: 'Playa Linda Beach Resort',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5TRsoWNN5th2idgYHWEUYE/unnamed_%283%29.png',
    description: 'Sesión fotográfica y video promocional'
  }, {
    name: 'Tryp By Wyndham',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t9AcqBTZc97z7oLWTJi33G/unnamed_%284%29.png',
    description: 'Campaña en redes sociales'
  }];
  return <div className="w-full bg-white" data-id="element-1027">
      <div className="max-w-5xl mx-auto" data-id="element-1028">
        <h2 className="text-3xl font-normal text-black mb-8" data-id="element-1029">
          Colaboraciones con Hoteles
        </h2>
        <p className="text-base text-gray-700 mb-10 leading-relaxed" data-id="element-1030">
          He tenido el privilegio de colaborar con reconocidas marcas hoteleras
          para crear contenido auténtico que conecta con sus audiencias y
          destaca sus experiencias únicas.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1031">
          {hotels.slice(0, 3).map((hotel, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-1032">
              <div className="aspect-video w-full overflow-hidden" data-id="element-1033">
                <img src={hotel.image} alt={hotel.name} className="w-full h-full object-cover" data-id="element-1034" />
              </div>
              <div className="p-6" data-id="element-1035">
                <h3 className="text-xl font-normal text-black mb-2" data-id="element-1036">
                  {hotel.name}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1037">{hotel.description}</p>
              </div>
            </div>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1038">
          {hotels.slice(3, 5).map((hotel, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-1039">
              <div className="aspect-video w-full overflow-hidden" data-id="element-1040">
                <img src={hotel.image} alt={hotel.name} className="w-full h-full object-cover" data-id="element-1041" />
              </div>
              <div className="p-6" data-id="element-1042">
                <h3 className="text-xl font-normal text-black mb-2" data-id="element-1043">
                  {hotel.name}
                </h3>
                <p className="text-sm text-gray-600" data-id="element-1044">{hotel.description}</p>
              </div>
            </div>)}
        </div>
        <div className="bg-gray-50 p-8 rounded-lg mt-12" data-id="element-1045">
          <h3 className="text-xl font-medium text-black mb-4" data-id="element-1046">
            Creación de contenido eficiente
          </h3>
          <p className="text-base text-gray-700 leading-relaxed" data-id="element-1047">
            Dile adiós a los costosos ciclos de producción. El contenido
            generado por el usuario es una solución rentable que escala sin
            esfuerzo, permitiéndote crear contenido de alta calidad a una
            fracción del costo.
          </p>
        </div>
      </div>
    </div>;
}